import { EuiFormRow, EuiSpacer, EuiTextArea } from "@elastic/eui";
import React, { useState } from "react";

import _ from "lodash";
import { FormattedMessage } from "react-intl";
import TripFieldForm from "../shared/TripFieldForm";
import TripSection from "../shared/TripSection";

// TODO: use configs
const notesKey = "notes";

function TripNotes({ defaultValue = "", onChange }) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [notes, setNotes] = useState(defaultValue);

    const openPopover = () => {
        setIsPopoverOpen(true);
    };

    const closePopover = () => {
        setIsPopoverOpen(false);
    };

    const onTextAreaChange = _.debounce((name, value) => {
        setNotes(value);
    }, 500);

    const handleSubmit = () => {
        setIsPopoverOpen(false);
        setIsLoading(true);
        onChange({ [notesKey]: notes }, () => setIsLoading(false));
    };

    const renderInput = () => (
        <>
            <EuiFormRow label={<FormattedMessage id="trip.notes" />}>
                <EuiTextArea
                    placeholder="Text goes here..."
                    name={notesKey}
                    onChange={(e) => onTextAreaChange(e.target.name, e.target.value)}
                    resize="none"
                    defaultValue={defaultValue}
                    fullWidth
                />
            </EuiFormRow>
            <EuiSpacer size="s" />
        </>
    );

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.notes" />}
            headerIconType="documents"
        >
            {defaultValue || "N/A"}

            <TripFieldForm
                openPopover={openPopover}
                closePopover={closePopover}
                isPopoverOpen={isPopoverOpen}
                isLoading={isLoading}
                input={renderInput()}
                onSubmit={handleSubmit}
                fullWidth
            />
        </TripSection>
    );
}

export default TripNotes;
